<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>{{ $t("facturasEmitidas") }} QR</template>
      </breadcrumb>

      <CabeceraInformes
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
      />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
            {{ $t('permisoControlModulos') }}
        </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta">
        <template v-if="dateInform.length > 0">
          <div class="row justify-content-between div-export">
            <div class="col-md-12  text-left">
              <el-dropdown>
                <el-button type="primary" size="small">
                  <i class="fa fa-file"></i>
                  {{ $t("exportarInforme") }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <a :href="urlExportPDF">
                    <el-dropdown-item class="text-danger">
                      <strong
                        ><i class="fa fa-file-pdf"></i>
                        {{ $t("exportarPdf") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                  <a :href="urlExportExcel">
                    <el-dropdown-item class="text-success">
                      <strong
                        ><i class="fa fa-file-excel"></i>
                        {{ $t("exportarExcel") }}</strong
                      >
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>

          <div class="table-responsive" style="overflow: auto">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr>
                  <th>
                    <span
                      v-if="ordenarDocNumber"
                      @click="sortedArrayASC(1), (ordenarDocNumber = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("factura") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(1), (ordenarDocNumber = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("factura") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarAccount"
                      @click="sortedArrayASC(2), (ordenarAccount = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("mesa") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(2), (ordenarAccount = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("mesa") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarDate"
                      @click="sortedArrayASC(3), (ordenarDate = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("fecha") }}
                    </span>
                    <span v-else @click="sortedArrayDESC(3), (ordenarDate = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("fecha") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarpaidType"
                      @click="sortedArrayASC(4), (ordenarpaidType = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("cobro") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(4), (ordenarpaidType = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("cobro") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarCifNif"
                      @click="sortedArrayASC(5), (ordenarCifNif = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("cifnif") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(5), (ordenarCifNif = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("cifnif") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarNameClient"
                      @click="sortedArrayASC(6), (ordenarNameClient = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("cliente") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(6), (ordenarNameClient = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("cliente") }}
                    </span>
                  </th>
                  <th>
                    <span
                      v-if="ordenarAmount"
                      @click="sortedArrayASC(7), (ordenarAmount = 0)"
                      ><i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("importe") }}
                    </span>
                    <span
                      v-else
                      @click="sortedArrayDESC(7), (ordenarAmount = 1)"
                      ><i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("importe") }}
                    </span>
                  </th>
                  <th>{{ $t("acciones") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in dateInform">
                  <td>
                    {{ obj.docNumber }}
                    <template v-if="obj.refDocNumber !== ''"
                      ><i
                        v-tooltip.top-center="obj.refDocNumber"
                        class="fas fa-info-circle text-danger"
                      ></i
                    ></template>
                  </td>
                  <td>{{ obj.account }}</td>
                  <td>{{ obj.date | parseDate }}</td>
                  <td v-if="obj.paidType === 'E'">{{ $t("efectivo") }}</td>
                  <td v-else-if="obj.paidType === 'T'">{{ $t("tarjeta") }}</td>
                  <td v-else-if="obj.paidType === 'C'">{{ $t("cheque") }}</td>
                  <td v-else-if="obj.paidType === 'A'">{{ $t("avanzado") }}</td>
                  <td>{{ obj.cifnif }}</td>
                  <td>{{ obj.nameClient }}</td>
                  <td align="right">{{ obj.amount | currency }}</td>
                  <td align="center">
                    <div class="btn btn-primary btn-link text-success">
                      <a :href="urlExportTicketExcel(obj.idHeader, obj.idTpv)">
                        <i
                          v-tooltip.top-center="$i18n.t('exportarExcel')"
                          class="fa fa-file-excel text-success"
                        ></i
                      ></a>
                    </div>

                    <div class="btn btn-primary btn-link text-danger">
                      <a
                        :href="urlExportTicketPDFReal(obj.idHeader, obj.idTpv)"
                      >
                        <i
                          v-tooltip.top-center="$i18n.t('exportarPdf')"
                          class="fa fa-file-pdf text-danger"
                        ></i>
                      </a>
                    </div>

                    <div class="btn btn-primary btn-link text-danger" v-if="obj.abonada != '1' && obj.docNumber.includes('FAQ')">
                      <span @click="abonarFacturaQr(obj.idHeader, obj.idTpv)">
                        <i v-tooltip.top-center="$i18n.t('abonarFacturaQr')"
                            class="fa fa-ban text-danger">
                        </i>
                      </span>
                    </div>

                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr class="table-success">
                  <td colspan="6" class="table-success">
                    <strong>{{ $t("total") }}:</strong>
                  </td>
                  <td class="text-right">
                    <strong>
                      {{ getTotalVentas | currency }}
                    </strong>
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayFacturasEmitidasEnEsteRangoDeFecha") }}
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  Loading,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import Datetime from "vue-datetime";
import { mapState } from "vuex";

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("facturasNominativas"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Datetime]: Datetime,
    [Option.name]: Option,
    Breadcrumb,
    CabeceraInformes,
  },
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      listBusinesses: [],
      idBusiness: 0,
      idTpv: 0,
      data: [""],
      listTpv: [],
      cuentasAparcadas: false,
      dateInform: ["-"],
      indice: 0,

      //ORDEN
      ordenarDocNumber: 0,
      ordenarAccount: 0,
      ordenarDate: 0,
      ordenarpaidType: 0,
      ordenarCifNif: 0,
      ordenarNameClient: 0,
      ordenarAmount: 0,

      respuesta: true,
    };
  },
  computed: {
    ...mapState(["permiso"]),
    urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidasQR/PDF?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidasQR/Excel?idTpv=" +
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    getTotalVentas() {
      let xtotal = 0;

      this.dateInform.forEach(function(x) {
        xtotal += x.amount;
      });

      return xtotal;
    },
  },
  methods: {
    sortedArrayASC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarDocNumber = 1;

          function compareDocNumber(a, b) {
            if (a.docNumber.toUpperCase() < b.docNumber.toUpperCase())
              return -1;
            if (a.docNumber.toUpperCase() > b.docNumber.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDocNumber);

        case 2:
          this.ordenarAccount = 1;

          function compareAccount(a, b) {
            if (a.account < b.account) return -1;
            if (a.account > b.account) return 1;
            return 0;
          }

          return this.dateInform.sort(compareAccount);

        case 3:
          this.ordenarDate = 1;

          function compareDate(a, b) {
            if (a.date < b.date) return -1;
            if (a.date > b.date) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDate);

        case 4:
          this.ordenarpaidType = 1;

          function comparePaidType(a, b) {
            if (a.paidType < b.paidType) return -1;
            if (a.paidType > b.paidType) return 1;
            return 0;
          }

          return this.dateInform.sort(comparePaidType);

        case 5:
          this.ordenarCifNif = 1;

          function compareCifNif(a, b) {
            if (a.cifnif.toUpperCase() < b.cifnif.toUpperCase()) return -1;
            if (a.cifnif.toUpperCase() > b.cifnif.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareCifNif);

        case 6:
          this.ordenarNameClient = 1;

          function compareNameClient(a, b) {
            if (a.nameClient.toUpperCase() < b.nameClient.toUpperCase())
              return -1;
            if (a.nameClient.toUpperCase() > b.nameClient.toUpperCase())
              return 1;
            return 0;
          }

          return this.dateInform.sort(compareNameClient);

        case 7:
          this.ordenarAmount = 1;

          function compareAmount(a, b) {
            if (a.amount < b.amount) return -1;
            if (a.amount > b.amount) return 1;
            return 0;
          }

          return this.dateInform.sort(compareAmount);
      }
    },
    sortedArrayDESC: function(nameAtributo) {
      switch (nameAtributo) {
        case 1:
          this.ordenarDocNumber = 0;

          function compareDocNumber(a, b) {
            if (a.docNumber.toUpperCase() > b.docNumber.toUpperCase())
              return -1;
            if (a.docNumber.toUpperCase() < b.docNumber.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDocNumber);

        case 2:
          this.ordenarAccount = 0;

          function compareAccount(a, b) {
            if (a.account > b.account) return -1;
            if (a.account < b.account) return 1;
            return 0;
          }

          return this.dateInform.sort(compareAccount);

        case 3:
          this.ordenarDate = 0;

          function compareDate(a, b) {
            if (a.date > b.date) return -1;
            if (a.date < b.date) return 1;
            return 0;
          }

          return this.dateInform.sort(compareDate);

        case 4:
          this.ordenarpaidType = 0;

          function comparePaidType(a, b) {
            if (a.paidType > b.paidType) return -1;
            if (a.paidType < b.paidType) return 1;
            return 0;
          }

          return this.dateInform.sort(comparePaidType);

        case 5:
          this.ordenarCifNif = 0;

          function compareCifNif(a, b) {
            if (a.cifnif.toUpperCase() > b.cifnif.toUpperCase()) return -1;
            if (a.cifnif.toUpperCase() < b.cifnif.toUpperCase()) return 1;
            return 0;
          }

          return this.dateInform.sort(compareCifNif);

        case 6:
          this.ordenarNameClient = 0;

          function compareNameClient(a, b) {
            if (a.nameClient.toUpperCase() > b.nameClient.toUpperCase())
              return -1;
            if (a.nameClient.toUpperCase() < b.nameClient.toUpperCase())
              return 1;
            return 0;
          }

          return this.dateInform.sort(compareNameClient);

        case 7:
          this.ordenarAmount = 0;

          function compareAmount(a, b) {
            if (a.amount > b.amount) return -1;
            if (a.amount < b.amount) return 1;
            return 0;
          }

          return this.dateInform.sort(compareAmount);
      }
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {
          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.cambioTpv(-1, false);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    cambioBusiness(idBusinessData, listTpv) {
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = -1;
      this.list = [];
      this.cambioTpv()
    },
    emitirConsulta() {
      this.getFacturasEmitida();
    },
    cambioTpv(idTpvData, filtrar) {
      this.idTpv = idTpvData;
      this.emitirConsulta();
    },
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listTpv = response.data.result;
            if (vm.listTpv.length > 0) {
              vm.idTpv = vm.listTpv[0].id;
              vm.getFacturasEmitida();
            }
          }
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          vm.loading.close();
        });
    },
    abonarFacturaQr(idHeader, idTpv) {
      swal({
        title: this.$t('deseasAbonarEstaFacturaQR'),
        text: this.$t('estaOperacionNoSePuedeDeshacer'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: this.$t('abonarFactura'),
        cancelButtonText: this.$t('cancelar'),
        buttonsStyling: true
      }).then((result) => {

        if (result.value) {
          this.loading = Loading.service({ text: "Cargando..." });

          var config = {
            params: {
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let params = {
            idTpv: idTpv,
            idHeader: idHeader,
          }

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .post(
              this.$store.getters.apiUrl + "sales/abonarFacturaQR",
              params,
              config
            )
            .then(function(response) {
              if (response.data.response) {
                vm.respuesta = true;
                vm.getFacturasEmitida();

              } else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }

              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      });
    },
    getFacturasEmitida() {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          this.loading = Loading.service({ text: "Cargando..." });

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idTpv: this.idTpv,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(
              this.$store.getters.apiUrl + "sales/getFacturasEmitidasQR",
              config
            )
            .then(function(response) {
              if (response.data.response) {
                vm.dateInform = response.data.result;

                vm.respuesta = true;
              }else if (response.data.response == false && response.data.rangoMayor == true) {
                    swal({
                      title: "Lo sentimos",
                      text: response.data.result,
                      confirmButtonClass: "btn btn-info btn-fill",
                      type: "info",
                    });
                    vm.respuesta = false;
              }  else {
                swal({
                  title: vm.$t("atencion"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },
    urlExportTicketPDF(idHeader) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidasByIdQR/PDF?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportTicketPDFReal(idHeader, idTpv) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidaByIdQR/PDF?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&idTpv=" +
        idTpv +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportTicketExcel(idHeader, idTpv) {
      return (
        this.$store.getters.apiUrl +
        "/sales/exportFacturasEmitidaByIdQR/Excel?idBusiness=" +
        this.idBusiness +
        "&idHeader=" +
        idHeader +
        "&idTpv=" +
        idTpv +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/FacturasEmitidasQR.vue